// extracted by mini-css-extract-plugin
export default {"tabs":"RuleModal_tabs__Ez8bk"};